import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import type { ReadonlyURLSearchParams } from 'next/navigation';
interface UseWaveNavigationOptions {
  readonly basePath: string;
  readonly onHover: (waveId: string) => void;
  readonly prefetchWaveData: (waveId: string) => void;
  readonly searchParams: ReadonlyURLSearchParams | null;
  readonly waveId: string;
}
interface UseWaveNavigationResult {
  readonly href: string;
  readonly isActive: boolean;
  readonly onMouseEnter: () => void;
}
export const useWaveNavigation = t0 => {
  const $ = _c(15);
  const {
    basePath,
    onHover,
    prefetchWaveData,
    searchParams,
    waveId
  } = t0;
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("wave") ?? undefined;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentWaveId = t1;
  let t2;
  bb0: {
    if (currentWaveId === waveId) {
      t2 = basePath;
      break bb0;
    }
    let t3;
    let t4;
    if ($[2] !== basePath || $[3] !== waveId) {
      const params = new URLSearchParams();
      params.set("wave", waveId);
      t3 = basePath;
      t4 = params.toString();
      $[2] = basePath;
      $[3] = waveId;
      $[4] = t3;
      $[5] = t4;
    } else {
      t3 = $[4];
      t4 = $[5];
    }
    t2 = `${t3}?${t4}`;
  }
  const href = t2;
  const isActive = waveId === currentWaveId;
  let t3;
  if ($[6] !== currentWaveId || $[7] !== onHover || $[8] !== prefetchWaveData || $[9] !== waveId) {
    t3 = () => {
      if (waveId === currentWaveId) {
        return;
      }
      onHover(waveId);
      prefetchWaveData(waveId);
    };
    $[6] = currentWaveId;
    $[7] = onHover;
    $[8] = prefetchWaveData;
    $[9] = waveId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onMouseEnter = t3;
  let t4;
  if ($[11] !== href || $[12] !== isActive || $[13] !== onMouseEnter) {
    t4 = {
      href,
      isActive,
      onMouseEnter
    };
    $[11] = href;
    $[12] = isActive;
    $[13] = onMouseEnter;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};